import "./elements/text-clamp/text-clamp";
import "./elements/cart/cart-count";
import "./elements/cart/cart-drawer";
import "./elements/cart/cart-page";
import "./elements/cart-quantity/cart-quantity";
import "./elements/predictive-search/predictive-search";
import "./elements/product-block-mobile-slider/product-block-mobile-slider";
import "./elements/side-drawer/side-drawer";
import "./elements/header-new/header-new";
import "./elements/header-new/promo-slider";
import "./elements/side-menu-offset/side-menu-offset";
import "./elements/size-chart-drawer/size-chart-drawer";
import "./elements/cart-size-modal/cart-size-modal";
import "./elements/quidget-button-styles/quidget-button-styles";
import "./elements/product-lightbox/product-lightbox";
import "./elements/media-banner/media-banner";
import "./elements/product-bnpl/product-bnpl";
import "./elements/foursixty-ambassadors/foursixty-ambassadors";
import "./elements/product-audio-player/product-audio-player";
import "./elements/wear-it-with/wear-it-with";
import "./elements/swym-wishlist/swym-wishlist";

import { setupCartAddForms } from "./elements/cart/cart-add-forms";
import { installCartWriteDetection } from "./elements/cart/cart-write-interceptor";

setupCartAddForms();
installCartWriteDetection();
